require.register("modules/m02/m02-activity/page-28/page-28", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page28 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page28;

  
});

